
import React, { useEffect } from 'react'
import "../styles/Gallery.css"
import g1 from "../assets/images/g1.webp"
import g2 from "../assets/images/g2.webp"
import g3 from "../assets/images/g3.webp"
import g4 from "../assets/images/g7.webp"
import g6 from "../assets/images/g6.webp"
import g8 from "../assets/images/g8.webp"
import g9 from "../assets/images/g9.webp"
import g10 from "../assets/images/g10.webp"
import g11 from "../assets/images/g11.webp"
import g12 from "../assets/images/g12.webp"
import { useLocation } from 'react-router-dom'


const Gallery = () => {
    const location = useLocation();

    useEffect(() => {
        if (location.state?.scrollToId) {
            const el = document.getElementById(location.state.scrollToId);
            if (el) {
                el.scrollIntoView({ behavior: "smooth" });
            }
        }
    }, [location]);

    return (
        <>
            <section class="gallery" id='gallerysection'>
                <article class="galleryRow">
                    <div class="heading">
                        <h2 class="slide-left slide-right">Gallery</h2>
                    </div>
                    <div class="col-12 p-0">
                        <article class="gallery-grid">
                            <article class="gallery">
                                <div class="gallery-wrapper">
                                    <div>
                                        <img src={g1} class="img-fluid" alt="" />
                                    </div>
                                    <div>
                                        <img src={g6} class="img-fluid" alt="" />
                                    </div>
                                    <div class="tall">
                                        <img src={g3} class="img-fluid" alt="" />
                                    </div>
                                    <div class="wide">
                                        <img src={g2} class="img-fluid" alt="" />
                                    </div>
                                    <div class="tall">
                                        <img src={g4} class="img-fluid" alt="" />
                                    </div>
                                </div>
                            </article>
                            <article class="gallery">
                                <div class="gallery-wrapper">
                                    <div>
                                        <img src={g9} class="img-fluid" alt="" />
                                    </div>
                                    <div>
                                        <img src={g10} class="img-fluid" alt="" />
                                    </div>
                                    <div class="tall">
                                        <img src={g11} class="img-fluid" alt="" />
                                    </div>
                                    <div class="wide">
                                        <img src={g12} class="img-fluid" alt="" />
                                    </div>
                                    <div class="tall">
                                        <img src={g8} class="img-fluid" alt="" />
                                    </div>
                                </div>
                            </article>
                        </article>
                    </div>
                </article>
            </section>
        </>
    )
}

export default Gallery